export default "__VITE_ASSET__G3ObKhP1__"